import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography, Button } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { useStyles } from '../cancelConnectPlanDialog.styles';

const ACKNOWLEDGEMENT_LABEL =
    'I understand that my integrations will stop syncing and I will lose access to Connect at the end of this billing cycle.';

function ConfirmStep ({
    titleId,
    onClose,
    checked,
    setChecked,
    error,
    handleConfirm,
}) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.header}>
                <div className={classes.headerLeft}>
                    <div>
                        <Typography id={titleId} className={classes.title}>
                            Deactivate Connect?
                        </Typography>
                        <Typography className={classes.subtitle}>
                            This action will cancel your subscription.
                        </Typography>
                    </div>
                </div>
                <IconButton
                    aria-label="Close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="small"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>

            <div className={classes.body}>
                <div className={classes.infoBox}>
                    <Typography className={classes.infoLabel}>
                        What happens when you cancel:
                    </Typography>
                    <ul className={classes.bulletList}>
                        <li>Your Connect integrations will cease at the end of the current billing period</li>
                        <li>Your transactions, including any unused, will expire at the end of the current billing period.</li>
                        <li>You can re-subscribe to Connect at any time.</li>
                    </ul>
                </div>

                <div className={classes.checkboxRow}>
                    <label className={classes.checkboxLabelWrap}>
                        <input
                            type="checkbox"
                            className={classes.checkboxInput}
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                        />
                        <span className={classes.checkboxLabel}>
                            {ACKNOWLEDGEMENT_LABEL}
                        </span>
                    </label>
                </div>

                {error && (
                    <div className={classes.errorRow}>
                        <Typography className={classes.errorText}>{error}</Typography>
                    </div>
                )}

                <div className={classes.footer}>
                    <Button
                        className={classes.keepBtn}
                        onClick={onClose}
                    >
                        Keep My Plan
                    </Button>
                    <Button
                        className={classes.cancelPlanBtn}
                        disabled={!checked}
                        onClick={handleConfirm}
                    >
                        Yes, Cancel Plan
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
}

ConfirmStep.propTypes = {
    titleId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    setChecked: PropTypes.func.isRequired,
    error: PropTypes.string,
    handleConfirm: PropTypes.func.isRequired,
};

ConfirmStep.defaultProps = {
    error: '',
};

export default ConfirmStep;
